import { apiPaths } from 'app/services/api';
import React from 'react';
import CrudGridForm from '../../smart-kit/Form/CrudGridForm';

export const transactionFields = [
  { label: 'Name', key: 'name', validation: { required: true } },
  {
    label: 'Type',
    key: 'type',
    type: 'radio',
    items: [
      { value: 'organisational', label: 'Organisational' },
      { value: 'individual', label: 'Individual' }
    ],
    validation: { required: true }
  },
  {
    label: 'Eligible Coach Level',
    key: 'eligible_coach_level',
    type: 'select',
    items: [
      { value: 'acc', label: 'ACC' },
      { value: 'pcc', label: 'PCC' },
      { value: 'mcc', label: 'MCC' }
    ],
    validation: { required: false }
  },
  {
    label: 'description',
    key: 'description',
    validation: { required: false },
    type: 'multiline'
  },
  {
    label: 'Min Number of Sessions',
    key: 'min_sessions',
    validation: { required: true },
    type: 'number'
  },
  {
    label: 'Max Number of Sessions',
    key: 'max_sessions',
    validation: { required: true },
    type: 'number',
    watch: true
  }
];
const TransactionForm = () => {
  const [fields, setFields] = React.useState(transactionFields);
  const [sessions, setSessions] = React.useState(0);

  const onChange = (data) => {
    if (data.max_sessions && sessions !== data.max_sessions) {
      setFields(transactionFields);
      setSessions(data.max_sessions);

      const newFields = [...transactionFields];
      newFields.push({
        group: 'Session 0',
        groupIndex: 0,
        label: `Session 0 Title`,
        key: `session_titles.session_0.title`,
        validation: { required: true },
        defaultValue: 'جلسه صفر'
      });
      newFields.push({
        group: 'Session 0',
        groupIndex: 1,
        label: `Session 0 Type`,
        key: `session_titles.session_0.type`,
        validation: { required: true },
        type: 'select',
        items: [{ value: 'zero_session', label: 'جلسه صفر' }]
      });
      for (let i = 0; i < data.max_sessions; i++) {
        newFields.push({
          group: `Session ${i + 1}`,
          groupIndex: 0,
          label: `Session ${i + 1} Title`,
          key: `session_titles.session_${i + 1}.title`,
          validation: { required: true }
        });
        newFields.push({
          group: `Session ${i + 1}`,
          groupIndex: 1,
          label: `Session ${i + 1} Type`,
          key: `session_titles.session_${i + 1}.type`,
          validation: { required: true },
          type: 'select',
          items: [
            { value: 'zero_session', label: 'جلسه صفر' },
            { value: 'routine_session', label: 'جلسه روتین' },
            { value: 'three_four_session', label: 'جلسه ۳گانه-۴گانه' }
          ]
        });
      }
      setFields(newFields);
    }
    // console.log(data.max_sessions)
  };
  return (
    <CrudGridForm
      path={apiPaths.TRANSACTIONS}
      name="Transaction"
      entityName={'transactions'}
      fields={fields}
      onChange={onChange}
    />
  );
};

export default TransactionForm;
